var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": 1,
    id: "_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M399,450H115a59.06,59.06,0,0,1-59-59V246a59.06,59.06,0,0,1,59-59h99.86a29,29,0,0,0,29-29h0a59.06,59.06,0,0,1,59-59H399a59.06,59.06,0,0,1,59,59V391A59.07,59.07,0,0,1,399,450ZM115,217a29,29,0,0,0-29,29V391a29,29,0,0,0,29,29H399a29,29,0,0,0,29-29V158a29,29,0,0,0-29-29H302.86a29,29,0,0,0-29,29,59.07,59.07,0,0,1-59,59Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121,217a15,15,0,0,1-15-15V63a15,15,0,0,1,15-15H393a15,15,0,0,1,15,15v51a15,15,0,0,1-30,0V78H136V202A15,15,0,0,1,121,217Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.64ccaf5c7b64068e4634e7ef7d99b265.svg";
export { ForwardRef as ReactComponent };